import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shell", "workspace", "details"]

  static values = {
    normalBottomMargin: { type: Number, default: 28 },
  }

  connect() {
    this.boundUpdate = this.updateLayout.bind(this)
    window.addEventListener("resize", this.boundUpdate)

    if (this.hasDetailsTarget) {
      this.detailsTarget.addEventListener("toggle", this.boundUpdate)
    }

    if (this.hasShellTarget && window.MutationObserver) {
      this.observer = new MutationObserver(this.boundUpdate)
      this.observer.observe(this.shellTarget, { attributes: true, attributeFilter: ["class"] })
    }

    if (window.MutationObserver) {
      this.domObserver = new MutationObserver(this.boundUpdate)
      this.domObserver.observe(this.element, { childList: true, subtree: true })
    }

    requestAnimationFrame(this.boundUpdate)
  }

  disconnect() {
    window.removeEventListener("resize", this.boundUpdate)
    if (this.hasDetailsTarget) {
      this.detailsTarget.removeEventListener("toggle", this.boundUpdate)
    }
    this.observer?.disconnect()
    this.domObserver?.disconnect()
  }

  updateLayout() {
    if (!this.hasShellTarget || !this.hasWorkspaceTarget) return

    const studioActive = this.shellTarget.classList.contains("documents-studio-active")
    const normalBottomMargin = studioActive ? 0 : this.normalBottomMarginValue
    const shellBody = this.shellTarget.querySelector(".documents-shell-body")
    const shellBodyBottom = shellBody
      ? (
        shellBody.getBoundingClientRect().bottom -
        Number.parseFloat(window.getComputedStyle(shellBody).paddingBottom || "0")
      )
      : window.innerHeight
    const availableBottom = studioActive
      ? Math.min(window.innerHeight, shellBodyBottom)
      : Math.max(window.innerHeight - normalBottomMargin, 0)
    const workspaceRect = this.workspaceTarget.getBoundingClientRect()
    const workspaceHeight = Math.max(availableBottom - workspaceRect.top, 320)

    this.element.style.setProperty("--documents-workspace-height", `${Math.round(workspaceHeight)}px`)

    const canvas = this.element.querySelector(".documents-canvas-viewport")
    const sidebar = this.element.querySelector(".documents-sidebar-body")

    if (canvas) {
      const canvasRect = canvas.getBoundingClientRect()
      const canvasHeight = Math.max(availableBottom - canvasRect.top, 240)
      this.element.style.setProperty("--documents-canvas-height", `${Math.round(canvasHeight)}px`)
    }

    if (sidebar) {
      const sidebarRect = sidebar.getBoundingClientRect()
      const sidebarHeight = Math.max(availableBottom - sidebarRect.top, 240)
      this.element.style.setProperty("--documents-sidebar-height", `${Math.round(sidebarHeight)}px`)
    }
  }

  clearLayout() {
    this.element.style.removeProperty("--documents-workspace-height")
    this.element.style.removeProperty("--documents-canvas-height")
    this.element.style.removeProperty("--documents-sidebar-height")
  }
}
